import React, { useEffect, useState } from 'react';
import { auth } from '../../firebase'; // Adjust the import path as necessary
import { NavLink } from 'react-router-dom';
import './Footer.css'; // Import CSS file for custom styles

const Footer = ({ theme }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setIsLoggedIn(!!user);
    });

    return () => unsubscribe();
  }, []);

  const lineStyle = {
    height: '2px',
    width: '100%',
    marginBottom: '10px',
    backgroundColor: theme === 'dark' ? 'white' : 'black'
  };

  console.log('Theme:', theme);
  console.log('Logged In:', isLoggedIn);

  return (
      <footer className={`footer mt-auto py-3 ${theme}`} style={{ backgroundColor: theme === 'dark' ? 'rgba(0, 0, 0, 0.9)' : 'rgba(255, 255, 255, 0.9)' }}>
        <div style={lineStyle}></div>
        <div className="point"></div>
        <div className="container">
          <br />
          <div className={`main ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>CINESAGE</div>
          <br />
          <div className="row justify-content-center">
            <div className="col-md-3 col-sm-6">
              <div className="text-center">
                <div>
                  <h5 className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Company</h5>
                  <ul className="list-unstyled">
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/aboutus">About</NavLink></li>
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="#">Jobs</NavLink></li>
                    <li>
                      {isLoggedIn ? (
                          <NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/contact">Contact</NavLink>
                      ) : (
                          <span className={`${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Contact</span>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="text-center">
                <div>
                  <h5 className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Links</h5>
                  <ul className="list-unstyled">
                    <li>
                      {isLoggedIn ? (
                          <NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/contact">Help Center</NavLink>
                      ) : (
                          <span className={`${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Help Center</span>
                      )}
                    </li>
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/termandprivacy">Terms of Use</NavLink></li>
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/termandprivacy">Privacy</NavLink></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="text-center">
                <div>
                  <h5 className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Account</h5>
                  <ul className="list-unstyled">
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="#">Account</NavLink></li>
                    <li>
                      {isLoggedIn ? (
                          <NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/watchlist">Movie</NavLink>
                      ) : (
                          <span className={`${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Movie</span>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="text-center">
                <div>
                  <h5 className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Follow Us</h5>
                  <ul className="list-unstyled">
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="https://www.facebook.com/YourAccountName" target="_blank" rel="noopener noreferrer">Facebook</NavLink></li>
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="https://www.twitter.com/YourAccountName" target="_blank" rel="noopener noreferrer">Twitter</NavLink></li>
                    <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="https://www.instagram.com/cinesage_recommender?igsh=MWQ1YXBlbXJucmpweA==" target="_blank" rel="noopener noreferrer">Instagram</NavLink></li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
          <br />
          <ul className={`footer-options text-center py-2 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
            <li>&copy; 2024 Cine Sage</li>
            <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/termandprivacy">Privacy & Legal</NavLink></li>
            <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="#">Ad Choices</NavLink></li>
            <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/termandprivacy">Accessibility</NavLink></li>
            <li><NavLink className={` ${theme === 'dark' ? 'text-white' : 'text-dark'}`} to="/termandprivacy">Manage Cookies</NavLink></li>
          </ul>
        </div>
      </footer>
  );
};

export default Footer;
